export const PLACEHOLDERS = [
  { key: 'customer_name', label: 'Customer name' },
  { key: 'company', label: 'Company' },
  { key: 'agent_name', label: 'Your name' },
];

export const applyPlaceholders = (text, values = {}) =>
  (text || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (m, key) => (values[key] != null && values[key] !== '' ? values[key] : m === '{{customer_name}}' ? 'there' : ''));

export const htmlToText = (html) => {
  const div = document.createElement('div');
  div.innerHTML = (html || '').replace(/<\/(p|div|li|h[1-6])>/gi, '\n').replace(/<br\s*\/?>/gi, '\n');
  return div.textContent.replace(/\n{3,}/g, '\n\n').trim();
};

const escapeHtml = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
export const textToHtml = (text) => (text || '').split(/\n/).map((l) => `<p>${escapeHtml(l) || '&nbsp;'}</p>`).join('');

export const isBlankHtml = (html) => !htmlToText(html);

export const readFileAsBase64 = (file) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(String(r.result).split(',')[1] || '');
  r.onerror = reject;
  r.readAsDataURL(file);
});

export const fmtBytes = (n) => (n > 1048576 ? `${(n / 1048576).toFixed(1)} MB` : n > 1024 ? `${Math.round(n / 1024)} KB` : `${n || 0} B`);

export const nameFromEmail = (email) => {
  const local = (email || '').split('@')[0] || '';
  return local.split(/[._-]+/).filter(Boolean).map((w) => w[0].toUpperCase() + w.slice(1)).join(' ');
};

export const initials = (name) => (name || '?').split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() || '').join('') || '?';

const AVATAR_COLORS = ['bg-amber-100 text-amber-800', 'bg-sky-100 text-sky-800', 'bg-emerald-100 text-emerald-800', 'bg-rose-100 text-rose-800', 'bg-violet-100 text-violet-800', 'bg-teal-100 text-teal-800'];
export const avatarColor = (key) => AVATAR_COLORS[[...(key || '')].reduce((a, c) => a + c.charCodeAt(0), 0) % AVATAR_COLORS.length];
